import React from 'react';
import { NavLink } from 'react-router-dom';
var PageNavItem = function (_a) {
    var to = _a.to, name = _a.name, className = _a.className, active = _a.active, disabled = _a.disabled, icon = _a.icon, onClick = _a.onClick, id = _a.id;
    var classNameResult = 'gr-page-nav-item ' +
        (active ? 'active ' : '') +
        (disabled ? 'disabled ' : '') +
        (className ? className : '');
    var renderSelectNavItem = function () {
        if (to) {
            return (React.createElement(NavLink, { draggable: false, id: id, to: to, className: classNameResult, onClick: function (e) {
                    disabled && e.preventDefault();
                } },
                icon && icon,
                name));
        }
        else {
            return (React.createElement("div", { className: classNameResult, id: id, onClick: onClick },
                icon && icon,
                name));
        }
    };
    return React.createElement(React.Fragment, null, renderSelectNavItem());
};
export { PageNavItem };
//# sourceMappingURL=PageNavItem.js.map